// Enums are dictionary of names versus numbers. This is so they work in the same way as C# enums (and other languages) which allow multiple names to have the same number.

let sampleStorageEnum = {
    'Fridge': 0,
    'CoolShed': 1,
    'HotShed': 2
};

export default sampleStorageEnum;
